import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
} from "@mui/material";
import DoneImage from "../../Components/assets/Images/errorImage.svg";
import styles from "./AccountClosureAddFunds.module.scss";
import { stageDetailsAPICall } from "./APICallsAccountClosure";

export default function AccountClosureAddFunds() {
  const [amount, setamount] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
    StageDetails();
  }, []);
  const handleNavigate = () => {
    window.open("https://app.firstock.in/login", "_blank");
    // window.location.href = "https://login.thefirstock.com/";
  };

  const StageDetails = () => {
    let obj: any = {
      stage: "account_settlement",
      request_id: sessionStorage.getItem("acrequestID"),
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        setamount(response.data.data.data.margin);
      })
      .catch((error: any) => {
        //  console.log("error", error);
      });
  };
  return (
    <>
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            <img src={DoneImage} />
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                Action Required!
                <br />
                Debit Balance of ₹.{amount?.toString()} Detected in Your Account
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  To proceed with closing your account, please add the necessary
                  funds to settle the outstanding balance.
                </p>
              </div>
            </div>
          </div>
          <Button
            variant="contained"
            sx={{ width: "187px", marginTop: "20px", height: "50px" }}
            onClick={handleNavigate}
          >
            Login
          </Button>
        </div>
      </div>
    </>
  );
}
